import api from './api';

export const getAdminPreOrderItems = async () => {
  const response = await api.get('/admin/pre-order/items/');
  return response.data;
};

export const createAdminPreOrderItem = async (payload) => {
  const response = await api.post('/admin/pre-order/items/', payload);
  return response.data;
};

export const getAdminPreOrderItem = async (itemId) => {
  const response = await api.get(`/admin/pre-order/items/${itemId}/`);
  return response.data;
};

export const updateAdminPreOrderItem = async (itemId, payload) => {
  const response = await api.patch(`/admin/pre-order/items/${itemId}/`, payload);
  return response.data;
};

export const deleteAdminPreOrderItem = async (itemId) => {
  const response = await api.delete(`/admin/pre-order/items/${itemId}/`);
  return response.data;
};
